import React from "react";

export function SuccessAlert(props) {
  return <div className="show_s_message success_message">{props.message}</div>;
}

export function ErrorAlert(props) {
  return <div className="show_s_message error_message">{props.message}</div>;
}
